import { Loader } from '../../../_core/loader.component';
import { useRequestWithAuth } from '../../../domains/request/request.service';
import { RequestPageContainer } from '../request-page.container';
import ErrorPage from '../../InfoPages/error.page';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ROUTE_PATHS } from '../../../../_routes';
import toast from 'react-hot-toast';

interface IAuthorizedRequestPageWrapper {
  requestId: string;
}

export const AuthorizedRequestPageWrapper = ({ requestId }: IAuthorizedRequestPageWrapper) => {
  const { request, loading, error } = useRequestWithAuth({ _id: requestId });
  const navigate = useNavigate();

  useEffect(() => {
    if ((!request || error) && !loading) {
      // Show error to user before redirecting
      if (error) {
        const errorMessage = error.message?.toLowerCase().includes('permission')
          ? 'You do not have permission to view this request'
          : error.message?.toLowerCase().includes('not found')
          ? 'Request not found'
          : 'Unable to load request';

        console.error('Failed to load request:', {
          requestId,
          error: error.message,
          networkError: error.networkError,
          graphQLErrors: error.graphQLErrors
        });

        toast.error(errorMessage);
      } else if (!request) {
        console.error('Request not found:', { requestId });
        toast.error('Request not found');
      }

      navigate(ROUTE_PATHS.DASHBOARD);
    }
  }, [loading, navigate, request, error, requestId]);

  if (!request)
    if (loading) return <Loader />;
    else return <ErrorPage>Request not found</ErrorPage>;

  if (!request?.editable) return <ErrorPage>You are missing sufficient permissions to view this request</ErrorPage>;

  return <RequestPageContainer request={request} />;
};
